import { c as _c } from "react/compiler-runtime";
import GoverningCouncilHero from "@/components/council/GoverningCouncilHero";
import GoverningCouncilMember from "@/components/council/GoverningCouncilMember";
import ResearchCTA from "@/components/home/ResearchCTA";
import SeoHead from "@/components/seo/SeoHead";
import { breadcrumbJsonLd, seoFromPage } from "@/lib/seo";
import { GOVERNING_COUNCIL_MEMBERS } from "@/data/governingCouncilData";
export default function GoverningCouncilPage() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = seoFromPage("governingCouncil");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const seo = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SeoHead {...seo} jsonLd={breadcrumbJsonLd([{
      name: "Home",
      path: "/"
    }, {
      name: "Councils",
      path: "/governing-council"
    }, {
      name: "Governing Council",
      path: "/governing-council"
    }])} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <GoverningCouncilHero totalMembers={GOVERNING_COUNCIL_MEMBERS.length} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <>{t1}<main className="min-h-screen bg-[#F4EFE6]">{t2}<div className="relative">{GOVERNING_COUNCIL_MEMBERS.map(_temp)}</div><ResearchCTA /></main></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(member, idx) {
  return <GoverningCouncilMember key={member.id} member={member} isEven={idx % 2 === 1} />;
}